export default __webpack_public_path__ + "static/media/up-location-icon.5bf73d27.svg";